import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore'
import Menu from '../panel/Menu';

export default function Paymentmode() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [paymentmodes, setpaymentmodes] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [paymode, setpaymode] = useState("");
    const [status, setstatus] = useState("Active");

    const [updocid, setupdocid] = useState("");
    const [uppaymode, setuppaymode] = useState("");
    const [upstatus, setupstatus] = useState("");

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'paymentmodes'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setpaymentmodes(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = paymentmodes.filter((item) =>
                item.data.paymode.toUpperCase().includes(searchText.toUpperCase())
            );
            setpaymentmodes(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const handleSubmit = async () => {
        try {
            await addDoc(collection(db, "paymentmodes"), {
                paymode: paymode,
                status: status,
                uid: userData.uid,
                createdAt: Timestamp.now(),
            });

            setpaymode("");
            setstatus("Active");
            fetchData1();

            Toast.fire({
                icon: "success",
                title: 'Payment Mode Added Successfully!!'
            });
        } catch (err) {
            Toast.fire({
                icon: "error",
                title: 'Error in Room Service Adding!!'
            });

            console.log(err.message);
        }
    }

    const handleDelete = async (docid, imgLink) => {
        const taskDocRef = doc(db, 'paymentmodes', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: 'Payment Mode Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, paymode, status) => {
        setupdocid(id);
        setuppaymode(paymode);
        setupstatus(status);
    }

    const handleUpdate = async () => {
        if (!uppaymode) {
            Toast.fire({
                icon: "error",
                title: 'Please Enter Required Fields!!'
            });
            return;
        }

        await updateDoc(doc(db, "paymentmodes", updocid), {
            paymode: uppaymode,
            status: upstatus,
        });
        Toast.fire({
            icon: "success",
            title: 'Payment Mode Updated Successfully!!'
        });

        fetchData1();
    }


    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Payment Mode  Mgmt ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Payment Mode</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Payment Mode </th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            paymentmodes.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.paymode}</td>
                                                    <td>{item.data.status}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.paymode, item.data.status)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id, item.data.imageurl) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Payment Mode</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Payment Mode </label>
                                    <input type="text" value={paymode} onChange={(e) => setpaymode(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label>Status</label>
                                    <select className='form-control' value={status} onChange={(e) => setstatus(e.target.value)}>
                                        <option value="Active">Active</option>
                                        <option value="Deactive">Deactive</option>
                                    </select>
                                </div>

                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Payment Mode</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Payment Mode </label>
                                    <input type="text" value={uppaymode} onChange={(e) => setuppaymode(e.target.value)} className="form-control" />
                                </div>

                                <div className="col-sm-6 mt-2">
                                    <label>Status</label>
                                    <select className='form-control' value={upstatus} onChange={(e) => setupstatus(e.target.value)}>
                                        <option value="Active">Active</option>
                                        <option value="Deactive">Deactive</option>
                                    </select>
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
